import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { map, tap } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { PrimeEvent } from 'src/app/ui/shared/event-listeners/prime/prime.event';
import { countryConfig } from 'src/country-config/country-config';
import { getPrimeSubscriptionAction } from '../../actions/prime-subscription.actions';
import { PrimeService } from '../../networking/services/prime/prime.service';
import { LocalStorageManager } from '../local-storage/local-storage.manager';
import { SessionStorageManager } from '../session-storage/session-storage.manager';
import {LocationManager} from '../location/location.manager';


@Injectable({
  providedIn: 'root',
})
export class PrimeManager {
  isBrowser;
  constructor(
    private primeService: PrimeService,
    private primeEvent : PrimeEvent,
    private ssm: SessionStorageManager,
    private lsm: LocalStorageManager,
    private store: Store<AppState>,
    private locationManager: LocationManager,
    @Inject(PLATFORM_ID) platformId
  ) { 
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);
  }

  getUserPlan(customerId){
    const idCustomerWebSafe = this.lsm.get('customer')?.idCustomerWebSafe;
    this.primeService.getPrimeSubscription(customerId, idCustomerWebSafe ).subscribe( res => {
      this.primeEvent.changePrimeUser( res );
    })

    return this.primeService.getPrimeSubscription(customerId,idCustomerWebSafe );
  }

  cancelSubscription() {
    return this.primeService.cancelSubscription();
  }

  changePaymentMethod() {
    return this.primeService.changePaymentMethod();
  }

  getPrimeCart () {
    return this.primeService.getPrimeCart();
  }

  getCustomerPrimeCart(customerId, params): Observable<any> {
    params.customerId = customerId || 0;
    return this.primeService.getCustomerPrimeCart(params.customerId, params);
  }

  changePrimePaymentMethod(customerId, creditCardId) :Observable<any> {
    return this.primeService.changePrimePaymentMethod(customerId, creditCardId);
  }

  primeCancel(customerId):Observable<any>{
    return this.primeService.primeCancel(customerId);
  }

  getPrimeSubscription(customerId):Observable<any> {
    const idCustomerWebSafe = this.lsm.get('customer')?.idCustomerWebSafe;
    if( this.ssm.get( 'primeSubscription' ) ){
      return of( this.ssm.get( 'primeSubscription' ) );
    }
    return this.primeService.getPrimeSubscription(customerId,idCustomerWebSafe).pipe(tap(subscription => {
      this.store.dispatch( getPrimeSubscriptionAction( { sub: subscription } ) );
      this.ssm.set('primeSubscription', subscription);
      })
    );
  }

  getPrimeStripHome(){
    const defaultTokens = countryConfig.ssrTokens;
    const customer = this.isBrowser ? this.ssm.get('customer') : null;
    const idStore = this.isBrowser ? parseInt(this.locationManager.getIdStoreGroup(), 10) : 26;
    let data = {
      idStoreGroup: idStore,
      idCustomerWebSafe: customer?.idCustomerWebSafe || defaultTokens?.idCustomerWebSafe,
      tokenIdWebSafe: customer?.token?.tokenIdWebSafe || defaultTokens?.token?.tokenIdWebSafe,
      token: customer?.token?.token || defaultTokens?.token?.token,
      source: 'WEB',
      city: this.isBrowser ? (idStore < 1000 ? (this.locationManager.city?.id || countryConfig.defaultCity) : '') : countryConfig.defaultCity,
    }
    return this.primeService.getPrimeStripHome(data);

  }

  getPrimeSubscriptionV2(customerId) {
   const idCustomerWebSafe = this.lsm.get('customer')?.idCustomerWebSafe;
    this.primeService.getPrimeSubscription(customerId,idCustomerWebSafe ).subscribe( subscription =>{
      this.store.dispatch( getPrimeSubscriptionAction( { sub: subscription } ) );
    });
  }

  primeSubscriptionFree(creditCardId: string, planType: string): Observable<any> {
    const idCustomerWebSafe = this.lsm.get('customer')?.idCustomerWebSafe;
    return this.primeService.primeSubscriptionFree({idCustomerWebSafe, creditCardId, planType});
  }

  getPrimeConfigStore(): Observable<any> {
    return this.store.select('prime')
      .pipe(map(({config}) => config[0]));
  }

  getPrimeSubscriptionStore(): Observable<any> {
    return this.store.select('primeSubs')
      .pipe(map(({sub: primeSubscription}) => primeSubscription));
  }

  getTermsAndConditionsPrimev1(): Observable<any> {
    return this.primeService.getTermsAndConditionsPrimeV1()
      .pipe(map( terms => terms?.value?.textEdit ));
  }

}
